




















import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreState } from '../../../store';
import vSelect from 'vue-select';

@Component({
    computed: {
        ...mapState({
            'extensionsList_schedul': (state: StoreState) => state.reports.filters.extensionsList_schedul,
            'extensionsList_selectAllSchedul': (state: StoreState) => state.reports.filters.extensionsList_selectAllSchedul,
            
        })
    },
    components: {
        vSelect
    }
})
export default class ExtensionsFilterSchedul extends Vue {

    extensionsList_schedul!: any[];

    mounted() {
        // var $vm = this;
        // const redirectToLogin = () => {
        //     (this as any).$router.push('login');
        // }
    //    this.$store.dispatch('getExtensions')
    //        .catch(redirectToLogin.bind(this))  
    }

    data() {  
        return {
            selectAll: false,
            selected: []
        };
    }

    get selectAll_Extn(){
         let found = true;
         if ((this as any).extensionsList_schedul.length > 0) {
          (this as any).extensionsList_schedul.forEach(ext => 
          {
              if(!ext.value){
                  found=false;
              }
          });
        }
        return found

    //   alert((this as any).extensionsList_schedul)

    //     var allselect=(this as any).extensionsList_selectAllSchedul;
    //     allselect=allselect.selectAll
      // return  allselect;
    }


    toggleExtension(ext: any) {
        const extensions = [...this.extensionsList_schedul];
        const thisExt = extensions.filter(e => e.ext === ext)[0];
     this.$store.commit('UPDATE_EXTENSIONS_LIST_SCHEDULE', {  
            extensions
        });
    }

    toggleAllExtensions(e) {
      
         var extensions = [...this.extensionsList_schedul];
        if(arguments.length === 0) {
            this.$data.selected = [];
            this.extensionsList_schedul.forEach(ext => {
                this.$data.selected.push(ext);
            });
            return;
        }
        this.$data.selectAll = e.target.checked;;//!this.$data.selectAll;

         var selectAll=this.$data.selectAll;
         
        this.$store.commit('UPDATE_EXTENSIONS_LIST_SELECTALLSCHEDULE', {
            selectAll
        });

        this.selectAll_Extn;

        let setValue = false;
        var extensionsList_schedul=this.extensionsList_schedul
        if (this.$data.selectAll) {
            setValue = true;
        }
        this.extensionsList_schedul.forEach(ext => {
            ext.value = setValue;
        });
        extensions= this.extensionsList_schedul;
        this.$store.commit('UPDATE_EXTENSIONS_LIST_SCHEDULE', {
            extensions
        });
    }

    extensionsChanged(selectedItems: any) {
        //alert('extensionsChanged')
       const selectedExtensions = selectedItems.map((e: any) => e.ext);
        const extensions = [...this.extensionsList_schedul]
            .map(e => {
                e.value = selectedExtensions.includes(e.ext);
                return e;
            });
        this.$store.commit('UPDATE_EXTENSIONS_LIST_SCHEDULE', {
            extensions
        });
    }
}
